module.exports = __webpack_public_path__ + "09_mole.9edc7072.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/papa/layer2/09_mole.png
// module id = 8QoL
// module chunks = 0